import React from "react";
import PropType from "prop-types";
import "./ShadowCard.css";

export default function ShadowCard(props) {
  return (
    <div
      className="shadow-card-container"
      style={{ minWidth: props.width, height: props.height }}
    >
      {props.children}
    </div>
  );
}

ShadowCard.propTypes = {
  children: PropType.node.isRequired,
  link: PropType.string.isRequired,
  width: PropType.string.isRequired,
  height: PropType.string.isRequired,
};
